<template>
  <div class="profil-wrapper mcp-profil">
    <h3>Profil</h3>

    <div class="form-group">
      <label>*Prénom</label>
      <input
        type="text"
        placeholder="Votre prénom"
        v-model="profil.first_name"
        v-validate="'required'"
        name="first_name"
        class="form-control"
      />
      <small v-show="errors.has('first_name')">{{ errors.first('first_name') }}</small>
    </div>

    <div class="form-group">
      <label>*Nom</label>
      <input
        type="text"
        placeholder="Votre nom"
        v-model="profil.last_name"
        v-validate="'required'"
        name="last_name"
        class="form-control"
      />
      <small v-show="errors.has('last_name')">{{ errors.first('last_name') }}</small>
    </div>

    <div class="form-group">
      <label>Entreprise</label>
      <input
        type="text"
        placeholder="Votre nom"
        v-model="profil.profile.company"
        v-validate="'required'"
        name="company"
        class="form-control"
      />
      <small v-show="errors.has('company')">{{ errors.first('company') }}</small>
    </div>

    <div class="form-group">
      <label>*Courriel</label>
      <input
        type="text"
        placeholder="Votre courriel"
        v-model="profil.email"
        v-validate="'required|email'"
        name="email"
        class="form-control"
      />
      <small v-show="errors.has('email')">{{ errors.first('email') }}</small>
    </div>

    <div class="form-group">
      <label>Adresse</label>
      <input
        type="text"
        placeholder="Votre adresse"
        v-model="profil.profile.address"
        v-validate="'required'"
        name="address"
        class="form-control"
      />
      <small v-show="errors.has('address')">{{ errors.first('address') }}</small>
    </div>

    <div class="form-group">
      <label>Téléphone</label>
      <input
        type="text"
        placeholder="Votre téléphone"
        v-model="profil.profile.phone"
        v-validate="'required'"
        name="phone"
        class="form-control"
      />
      <small v-show="errors.has('phone')">{{ errors.first('phone') }}</small>
    </div>

    <div class="form-group">
      <label>Ville</label>
      <input
        type="text"
        placeholder="Votre ville"
        v-model="profil.profile.city"
        v-validate="'required'"
        name="city"
        class="form-control"
      />
      <small v-show="errors.has('city')">{{ errors.first('city') }}</small>
    </div>
    <div class="form-group">
      <label>Code postal</label>
      <input
        type="text"
        placeholder="Votre ville"
        v-model="profil.profile.zip_code"
        v-validate="'required'"
        name="zip_code"
        class="form-control"
      />
      <small v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</small>
    </div>
    <button class="btn viewBtn" @click="SaveProfil()">Enregistrer</button>
  </div>
</template>

<script>
export default {
  name: "Profil",
  data() {
    return {
      profil: ""
    };
  },
  methods: {
    SaveProfil: function() {
      var data = {
        first_name: this.profil.first_name,
        last_name: this.profil.last_name,
        email: this.profil.email,
        profile: {
          city: this.profil.profile.city,
          company: this.profil.profile.company,
          address: this.profil.profile.address,
          phone: this.profil.profile.phone,
          zip_code: this.profil.profile.zip_code
        }
      };

      var dheader = {
        "Content-Type": "application/json",
        Authorization: "Token " + localStorage.getItem("token")
      };

      this.$http
        .post(this.$url_name + "/accounts/profile/", data, {
          headers: dheader
        })
        .then(response => {
          this.profil = response.body;
          this.$toasted.show("Votre profil a bien été enregistré!", {
            duration: 2000,
            type: "success"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    LoadData: function() {
      var dheader = {
        "Content-Type": "application/json",
        Authorization: "Token " + localStorage.getItem("token")
      };

      this.$http
        .get(this.$url_name + "/accounts/profile/", {
          headers: dheader
        })
        .then(response => {
          this.profil = response.body;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.LoadData();
  }
};
</script>

<style scoped>
.mcp-profil {
  width: 40%;
  padding: 10vh 10% 10vh 0;
  margin: 0 auto;
}
@media (max-width: 1999px) {
    .mcp-profil{width:50%;padding:10vh 0}
}
@media (max-width: 1023px) {
    .mcp-profil{width:75%;padding:10vh 0}
}
</style>


// WEBPACK FOOTER //
// src/components/Profil.vue